/**
 * Preferencias de UI no sensibles (ej. consentimiento de cookies) van en una
 * cookie propia, no en localStorage: ESLint bloquea `localStorage` en todo el
 * repo (regla `no-restricted-globals`, ver eslint.config.js) porque el token
 * de sesión vive solo en memoria. Esta cookie no lleva sesión ni PII, así que
 * no aplica esa regla — pero para no reabrir la discusión, usamos el mismo
 * mecanismo de almacenamiento del lado del cliente que el resto del proyecto
 * evita para datos de auth: una cookie simple, no HttpOnly, de duración larga.
 */
export function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : null
}

export function setCookie(name, value, days = 365) {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`
}
